<template>
  <div
    class="dg-lookup-control"
    :class="{ _hasAddVal: control.ableToAddLookUpVal && !control.readonly }"
  >
    <div class="row lookUpControl" v-if="labelPosition === 'left'">
      <div class="col-md-4">
        <label
          class="form-control-label"
          :class="{'bold': control.labelBold, 'italic': control.labelItalic, 'underline': control.labelUnderline}"
        >{{control.label}}</label>
      </div>
      <div class="col-md-8">
        <multiselect
          v-model="selectedLookUps"
          :options="lookups"
          :multiple="true"
          :close-on-select="false"
          :clear-on-select="false"
          :preserve-search="true"
          :searchable="true"
          placeholder
          label="text"
          selectLabel
          selectedLabel
          tagPlaceholder
          deselectLabel
          track-by="value"
          @select="save"
          @remove="save"
          :disabled="control.readonly"
          openDirection="bottom"
        />
      </div>
    </div>
    <div class="lookUpControl" v-else>
      <label
        class="form-control-label"
        :class="{'bold': control.labelBold, 'italic': control.labelItalic, 'underline': control.labelUnderline}"
      >{{control.label}}</label>
      <div>
        <multiselect
          v-model="selectedLookUps"
          :options="lookups"
          :multiple="true"
          :close-on-select="false"
          :clear-on-select="false"
          :preserve-search="true"
          :searchable="true"
          placeholder
          label="text"
          selectLabel
          selectedLabel
          tagPlaceholder
          deselectLabel
          track-by="value"
          @select="save"
          @remove="save"
          :disabled="control.readonly"
          openDirection="bottom"
        />
      </div>
    </div>
    <div v-if="control.ableToAddLookUpVal && !control.readonly" class="dg-lookup-control__addVal">
      <a href="#" @click.prevent="showLookUpModal">
        <icon name="plus" />
      </a>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { find } from 'lodash'
// services
import db from '@/services/db'

export default {
  props: ['control', 'labelPosition'],
  data() {
    return {
      rowKey: null,
      cellKey: null,
      options: null,
      lookUpTable: null,
      selectedLookUps: [],
    }
  },
  watch: {
    lookups() {
      this.setLookUpVal()
    },
  },
  computed: {
    ...mapState(['dataGrid_options']),
    lookUpTableDisplayColumn() {
      return this.dataGrid_options[this.lookUpTable].displayColumn
    },
    lookups() {
      const lookups = []
      const lookUpTableVals = $getGrid(this.lookUpTable)

      if (lookUpTableVals) {
        lookUpTableVals.map(row => {
          lookups.push({
            text: row[this.lookUpTableDisplayColumn],
            value: row.rowKey,
          })
        })
      }

      return lookups
    },
  },
  methods: {
    setLookUpVal() {
      this.selectedLookUps = []

      if (!this.control.value || !this.lookups.length) return

      const values = this.control.value.split(',')

      for (let value of values) {
        const lookup = find(this.lookups, { value })

        if (lookup) {
          this.selectedLookUps.push(lookup)
        } else {
          console.error(
            `[multi_lookup] - row "${value}" not found in "${this.lookUpTable}" grid`
          )
        }
      }
    },
    save() {
      this.$nextTick(() => {
        const value = this.selectedLookUps.length
          ? this.selectedLookUps.map(item => item.value).join(',')
          : null

        this.control.value = value

        const data = {
          options: this.options,
          rowKey: this.rowKey,
          cellKey: this.cellKey,
          value,
        }

        db.dataGrid.data.saveCellVal(data)
      })
    },
    showLookUpModal() {
      $dgAddRow(this.lookUpTable).then(rowKey => {
        $dgShowEditRowModal(this.lookUpTable, rowKey)
        this.selectedLookUps.push({ text: '', value: rowKey })
        this.save()
      })
    },
  },
  created() {
    this.$nextTick(() => {
      const formBuilderInst = this.$instByClass(this, 'form-builder-root')
      this.gridId = formBuilderInst.gridId
      this.rowKey = formBuilderInst.rowKey
      this.cellKey = this.control.propName
      this.options = this.dataGrid_options[formBuilderInst.gridId]
      this.lookUpTable = this.dataGrid_options[this.gridId].meta[
        this.cellKey
      ].lookUpTable

      this.setLookUpVal()
    })
  },
}
</script>
